import { useData } from "../runtime/provider";
import { useEffect } from "react";
import useInternetStatus from "@utils/internetStatus";
import { libraryQueryKey } from "@hooks/trpc/useLibrary/queryFunctions";

import { Platform } from "react-native";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

export default function useInvalidateLibrary() {
  const session = useData();
  const isLibraryPath = useNavigationStore((state) => state.isLibraryPath);
  const internetStatus = useInternetStatus();
  useEffect(() => {
    if (isLibraryPath && Platform.OS !== "web") {
      session.queryClient
        .invalidateQueries({
          queryKey: libraryQueryKey(),
        })
        .catch(console.error);
    }
  }, [internetStatus, isLibraryPath]);

  return null;
}
